import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';

import './style.less';

const CheckboxGroupButtons: React.FC<CheckboxGroupProps> = (props) => {
  return <Checkbox.Group {...props} className="custom-checkbox" />;
};

export default CheckboxGroupButtons;
